import {DataObjectImageDescriptor, TexturesApiService} from "@app/textures/service/textures-api.service"
import {DownloadFormat, ImageOpDataObject} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-data-object"
import {ImageOpDataObjectManagerCallback} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-data-object-manager-callback"
import {ImageOpContextHal} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/image-op-context-hal"
import {ImageTilesDescriptor} from "@cm/utils"
import {RetiledImage} from "@cm/browser-utils"

export class ImageOpDataObjectManager implements ImageOpDataObjectManagerCallback {
    constructor(
        readonly ctx: ImageOpContextHal,
        private texturesApi: TexturesApiService,
    ) {}

    dispose() {}

    async loadDataObjectImage(args: {dataObjectId: string; downloadFormat: DownloadFormat}): Promise<ImageOpDataObject> {
        let entry = this.dataObjectEntryById.get(args.dataObjectId)
        if (!entry) {
            const descriptor = await this.texturesApi.queryDataObjectImageDescriptor(args.dataObjectId)
            entry = {
                descriptor,
                dataObject: {
                    exr: undefined,
                    jpg: undefined,
                    tiles: undefined,
                },
            }
            this.dataObjectEntryById.set(args.dataObjectId, entry)
        }
        let imageOpDataObject = entry.dataObject[args.downloadFormat]
        if (!imageOpDataObject) {
            imageOpDataObject = new ImageOpDataObject(this, this.texturesApi, entry.descriptor, args.downloadFormat)
            entry.dataObject[args.downloadFormat] = imageOpDataObject
        }
        return imageOpDataObject
    }

    async loadTiledImage(imageTilesDescriptor: ImageTilesDescriptor): Promise<RetiledImage> {
        const tiledImage = await this.texturesApi.tiledImageManagerService.createTiledImage(imageTilesDescriptor)
        return new RetiledImage(tiledImage, {width: this.ctx.pageSize, height: this.ctx.pageSize}, 0)
    }

    private dataObjectEntryById = new Map<string, DataObjectEntry>()
}

type DataObjectEntry = {
    descriptor: DataObjectImageDescriptor
    dataObject: Record<DownloadFormat, ImageOpDataObject | undefined>
}
